import React, { useEffect, useState } from "react";
import Text from "./Text";

const Timer = ({ duration = 60, onComplete }) => {
  const [seconds, setSeconds] = useState(duration);

  useEffect(() => {
    if (seconds === 0) {
      onComplete && onComplete();
      return
    };

    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds]);

  const formatTime = () => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;

    return `${minutes?.toString()?.padStart(2, 0)}:${secs
      ?.toString()
      ?.padStart(2, 0)}`;
  };

  return (
    <Text
      text={formatTime()}
      className={"text-right"}
      color="text-dark-grey"
    />
  );
};

export default Timer;
